// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/highlights.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../core/common_pb";
import { file_proto_model_entity_place } from "../entity/place_pb";
import { file_proto_model_feature_activity_activity } from "../feature/activity/activity_pb";

/**
 * Describes the file proto/model/trip/highlights.proto.
 */
export const file_proto_model_trip_highlights = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_proto_model_core_common, file_proto_model_entity_place, file_proto_model_feature_activity_activity]);

/**
 * Describes the message carmen.HighlightMetadata.
 * Use `create(HighlightMetadataSchema)` to create a new message.
 */
export const HighlightMetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_highlights, 0);

/**
 * Describes the message carmen.Highlight.
 * Use `create(HighlightSchema)` to create a new message.
 */
export const HighlightSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_highlights, 1);

/**
 * Describes the message carmen.HighlightList.
 * Use `create(HighlightListSchema)` to create a new message.
 */
export const HighlightListSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_highlights, 2);

/**
 * Describes the enum carmen.HighlightList.ListStatus.
 */
export const HighlightList_ListStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_highlights, 2, 0);

/**
 * Status of this list
 *
 * @generated from enum carmen.HighlightList.ListStatus
 */
export const HighlightList_ListStatus = /*@__PURE__*/
  tsEnum(HighlightList_ListStatusSchema);

/**
 * Describes the message carmen.PersonalizedHighlight.
 * Use `create(PersonalizedHighlightSchema)` to create a new message.
 */
export const PersonalizedHighlightSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_highlights, 3);

/**
 * Describes the enum carmen.PersonalizedHighlight.HighlightStatus.
 */
export const PersonalizedHighlight_HighlightStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_highlights, 3, 0);

/**
 * User customizations
 *
 * @generated from enum carmen.PersonalizedHighlight.HighlightStatus
 */
export const PersonalizedHighlight_HighlightStatus = /*@__PURE__*/
  tsEnum(PersonalizedHighlight_HighlightStatusSchema);

/**
 * Describes the message carmen.PersonalizedHighlightList.
 * Use `create(PersonalizedHighlightListSchema)` to create a new message.
 */
export const PersonalizedHighlightListSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_highlights, 4);

/**
 * Describes the enum carmen.BestTimeToVisit.
 */
export const BestTimeToVisitSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_highlights, 0);

/**
 * Best time to visit a highlight
 *
 * @generated from enum carmen.BestTimeToVisit
 */
export const BestTimeToVisit = /*@__PURE__*/
  tsEnum(BestTimeToVisitSchema);

/**
 * Describes the enum carmen.SeasonalRelevance.
 */
export const SeasonalRelevanceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_highlights, 1);

/**
 * Seasonal relevance of a highlight
 *
 * @generated from enum carmen.SeasonalRelevance
 */
export const SeasonalRelevance = /*@__PURE__*/
  tsEnum(SeasonalRelevanceSchema);

